/**
* @description 考勤打卡设置
* @author daxiong
*/
<template>
  <div id="attendanceSet">
    <div class="group">
      <van-cell to="/lishui/jurisdiction/permissionSetting" is-link>
        <template #title>
          <span class="custom-title">权限设置</span>
        </template>
      </van-cell>
    </div>
    <div class="add-group">
      <van-cell @click="handleLoad">
        <template #title>
          <div class="cell-add">
            <van-icon name="add-o" />
            <span class="custom-title">新增考勤管理员</span>
          </div>
        </template>
      </van-cell>
    </div>
    <van-pull-refresh
      v-model="isLoading"
      @refresh="onRefresh"
      :style="groupList.length > 14 ? 'height:auto' : 'height:100%'"
    >
      <van-list
        v-model="isUpLoading"
        :finished="upFinished"
        @load="onLoad"
        :offset="offset"
        :finished-text="textBottom"
      >
        <div class="group">
          <van-cell
            v-for="(item, index) in groupList"
            :key="index"
            :value="item.value"
          >
            <template #title>
              <span class="custom-title">{{ item.staffName }}</span>
            </template>
            <template #right-icon>
              <van-icon
                name="close"
                class="close"
                size="20"
                @click="userDelete(item.mobile)"
              />
            </template>
          </van-cell>
        </div>
        <van-empty description="暂无记录" v-if="groupList.length === 0" />
      </van-list>
    </van-pull-refresh>

    <!-- 参与人员 -->
    <van-popup
      v-model="participantsShow"
      :key="timer"
      position="right"
      class="max-popup"
    >
      <participants
        @closePopupByParticipants="closePopupByParticipants"
      ></participants>
    </van-popup>
  </div>
</template>

<script>
import { getEmployeeAdmin, deleteEmployee } from "@api/lishui";
import { getLocalStorage } from "@utils";
import participants from "../components/userSet";

export default {
  components: { participants },
  data() {
    return {
      userInfo: JSON.parse(getLocalStorage("lishuiUserInfo"))
        ? JSON.parse(getLocalStorage("lishuiUserInfo"))
        : {},
      groupList: [],
      participantsShow: false,
      punchCardStaffVos: [],
      isLoading: false, //下拉刷新
      isUpLoading: false, //上拉加载
      upFinished: false, //上拉加载完毕
      finished: false,
      offset: 100, //滚动条与底部距离小于 offset 时触发load事件
      pages: 0,
      textBottom: "", //底部内容文字
      timer: "",
    };
  },
  computed: {},
  watch: {},
  methods: {
    // 下拉调用此函数
    onRefresh() {
      setTimeout(() => {
        // this.$toast("刷新成功"); //弹出
        this.isLoading = false;
      }, 500);
    },
    // 上拉调用此函数
    onLoad() {
      setTimeout(() => {
        this.isUpLoading = false;
        this.listPunchGroupSetting();
      }, 500);
    },
    /**
     * @description 查询考勤管理员列表
     */
    listPunchGroupSetting() {
      this.pages++;
      getEmployeeAdmin({
        creditCode: this.userInfo.creditCode,
        pageNum: this.pages,
        pageSize: 10,
      }).then((response) => {
        let res = response.data;
        if (res.code == "0000") {
          let lists = res.data.results;
          if (lists.length === 0) {
            this.upFinished = true;
          } else {
            this.upFinished = false;
          }
          for (var i = 0; i < lists.length; i++) {
            this.groupList.push(lists[i]); // 上拉时循环出来这个数组的三条内容，放入datacontent这个数组里，那样就一直拉一直加
          }
          if (this.groupList.length > 10) {
            this.textBottom = "我也是有底线的~~~";
          }
          //   this.groupList = res.data.results;
        } else {
          Toast({
            message: res.data.msg,
            position: "center",
            duration: 1000,
          });
        }
      });
    },
    /**
     * @description 删除管理员
     */
    userDelete(e) {
      deleteEmployee({
        creditCode: this.userInfo.creditCode,
        mobileList: e,
      }).then((response) => {
        console.log(res);
        let res = response.data;
        if (res.code === "0000") {
          this.$notify({
            type: "success",
            message: res.msg,
          });
          this.pages = 0;
          this.groupList = [];
          this.listPunchGroupSetting();
        } else {
          this.$notify({
            type: "warning",
            message: res.msg,
          });
        }
      });
    },
    /**
     * @description 关闭参与人员弹窗
     */
    handleLoad() {
      this.participantsShow = true;
      this.timer = new Date().getTime();
    },
    closePopupByParticipants(param) {
      this.participantsShow = false;

      // debugger
      if (param) {
        let arr = param.map((v) => {
          return {
            mobile: v.mobile,
            staffName: v.staffName,
          };
        });
        this.pages = 0;
        this.groupList = [];
        this.listPunchGroupSetting();
        // this.condition.punchCardStaffVos = arr;
      }
    },
  },
  created() {
    this.listPunchGroupSetting();
  },
  mounted() {
    console.log(this.userInfo)

  },
};
</script>
<style lang='scss' scoped>
#attendanceSet {
  height: calc(100vh - 60px);
  font-size: 14px;
  .max-popup {
    width: 100%;
    height: 100%;
  }
  .add-group {
    margin: 8px 0;
  }
  ::v-deep .van-cell {
    &__title {
      .cell-add {
        display: flex;
        align-items: center;
        color: #0091ff;
        i {
          margin-right: 5px;
        }
      }
    }
  }
}
</style>